import { render } from "./OtpDialog.vue?vue&type=template&id=c932ba4a&scoped=true"
import script from "./OtpDialog.vue?vue&type=script&lang=js"
export * from "./OtpDialog.vue?vue&type=script&lang=js"

import "./OtpDialog.vue?vue&type=style&index=0&id=c932ba4a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c932ba4a"]])

export default __exports__